import type { MaybeRefOrGetter, ComputedRef } from 'vue';
import type { QueryEventResult } from '~/sanity/types';

type EventTheme = Exclude<NonNullable<QueryEventResult>['theme'], undefined>;

const eventThemeClassMap: Record<EventTheme, string> = {
  'blue-green': 'event-theme-blue-green',
  'green-red': 'event-theme-green-red',
  'neon-orange': 'event-theme-neon-orange',
  'neon-violet': 'event-theme-neon-violet',
  'neon-blue': 'event-theme-neon-blue',
  orange: 'event-theme-orange',
  purple: 'event-theme-purple',
  'vibrant-green': 'event-theme-vibrant-green',
};

const DEFAULT_THEME: EventTheme = 'blue-green';

export const useEventTheme = ({
  theme,
}: {
  theme: MaybeRefOrGetter<EventTheme | null>;
}): {
  eventThemeClass: ComputedRef<string>;
  getEventBackgroundImage: () => string;
  getEventHeroBackgroundImage: () => string;
} => {
  const { $staticImages } = useNuxtApp();

  const resolvedTheme = computed((): EventTheme => {
    return toValue(theme) ?? DEFAULT_THEME;
  });

  const eventThemeClass = computed((): string => {
    return eventThemeClassMap[resolvedTheme.value];
  });

  const getEventBackgroundImage = (): string => {
    return $staticImages[resolvedTheme.value];
  };

  const getEventHeroBackgroundImage = (): string => {
    return $staticImages[`${resolvedTheme.value}-hero` as keyof typeof $staticImages];
  };

  return {
    eventThemeClass,
    getEventBackgroundImage,
    getEventHeroBackgroundImage,
  };
};
